/** @format */

export default function() {
  return [
    // {
    //   title: '序号',
    //   width: 70,
    //   customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`,
    // },
    {
      title: '车场名称',
      dataIndex: 'parkName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '车牌号',
      dataIndex: 'plate',
      width: 120
    },
    {
      title: '入场时间',
      dataIndex: 'enterTime',
      width: 200
    },
    {
      title: '入场通道',
      dataIndex: 'enterChannelName',
      width: 150,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '停车时长',
      dataIndex: 'parkingTime',
      width: 200,
      sortable: true
    },
    {
      title: '车辆类型',
      dataIndex: 'authTypeName',
      width: 150,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '停车订单号',
      dataIndex: 'pkOrderId',
      width: 340,
      scopedSlots: { customRender: 'pkOrderId' }
    },
    {
      title: '查看车辆图片',
      dataIndex: 'image',
      width: 110,
      scopedSlots: { customRender: 'viewImg' }
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      width: 150,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '清理时间',
      dataIndex: 'cleanTime',
      width: 200,
      sortable: true
    },
    {
      title: '下发状态',
      dataIndex: 'issuedStatusName',
      width: 100,
      scopedSlots: { customRender: 'status' }
    }
    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 154,
    //   scopedSlots: { customRender: 'operation' },
    // },
  ];
}
